






































































































































































































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IPolicy, ITask, PolicyStatus } from 'admiral-core';
import {
  BoxIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DollarSignIcon,
  Edit2Icon,
  HashIcon,
  MoreVerticalIcon,
  PieChartIcon,
  PlusIcon,
  TrashIcon,
  TrendingUpIcon,
  UserIcon,
  XIcon,
  FileIcon,
} from 'vue-feather-icons';
import dayjs from 'dayjs';
import 'vue-select/dist/vue-select.css';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import Avatar from '@/components/common/Avatar.vue';
import { Util } from '@/utils/Util';
import Multiselect from 'vue-multiselect';
import { FormatMixin } from '@/mixins/FormatMixin';
import PolicyStatusCheckbox from '@/views/pages/policies/PolicyStatusCheckbox.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import PoliciesColumnSelect from '@/views/pages/policies/PoliciesColumnSelect.vue';
import EditPolicyModal from '@/views/pages/policies/EditPolicyModal.vue';
import { PolicyApi } from '@/services/PolicyApi';
import PolicyProductLink from '@/components/common/PolicyProductLink.vue';
import PolicyTagLink from '@/components/common/PolicyTagLink.vue';
import PolicyUserLink from '@/components/common/PolicyUserLink.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { PreferencesAction } from '@/store/PreferencesModule';
import _get from 'lodash.get';
import AntragsbuchColumnSelect from '@/views/pages/policies/AntragsbuchColumnSelect.vue';
export type Order = 'desc' | 'asc';
export type ColumnName = string;
export interface SortValue {
  columnName: ColumnName;
  order: Order;
}

@Component({
  components: {
    AntragsbuchColumnSelect,
    PolicyUserLink,
    PolicyTagLink,
    PolicyProductLink,
    EditPolicyModal,
    PoliciesColumnSelect,
    PlusIcon,

    HorizontalPolicyStatusSelect,
    PolicyStatusCheckbox,
    TrendingUpIcon,
    UserIcon,
    BoxIcon,
    DollarSignIcon,
    HashIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    PieChartIcon,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
    Avatar,
    Multiselect,
    CheckIcon,
    XIcon,
    FileIcon,
  },
})
export default class TasksTableOverview extends mixins(BaseMixin, FormatMixin, PermissionMixin) {
  @Prop({ required: true, type: Array })
  tasks!: ITask[];

  @Prop({ required: true, type: Array })
  columns!: ColumnName[];

  @Prop({ type: Boolean, default: () => true })
  search!: boolean;

  @Prop({ required: false, type: Number })
  tasksPerPage!: number;

  @Prop({ type: Boolean, default: () => false })
  isLoading!: boolean;

  @Prop({ type: Boolean, default: () => false })
  hasSelectItemColumn!: boolean;

  selectedTask?: Partial<ITask> = {};

  isContentHovered = false;

  scrolled = false;

  currentPage = 0;

  searchQuery = '';

  sortValue: SortValue = {
    columnName: 'updatedAt',
    order: 'desc',
  };

  get itemsPerPage() {
    return this.tasksPerPage ?? 10;
  }

  async mounted() {
    //
  }

  pagesCount() {
    return Math.ceil(this.filteredTasks().length / this.itemsPerPage);
  }
  paginationCount() {
    return Math.ceil(this.filteredTasks().length / this.itemsPerPage);
  }

  @Watch('searchQuery')
  watchSearchQuery() {
    if (this.searchQuery.length === 0 || this.searchQuery.length === 1) {
      this.currentPage = 0;
    }
  }

  filteredTasks(): ITask[] {
    const result: ITask[] = this.tasks;

    if (this.searchQuery.length > 2) {
      return result.filter((task: ITask) =>
        JSON.stringify(task).toLowerCase().includes(this.searchQuery.toLowerCase()),
      );
    }
    return result;
  }

  formatOnlyDate(date: Date) {
    return Util.formatDate2(date);
  }

  formatDate(date: Date) {
    return Util.formatDate(date);
  }

  formatDateFull(date: Date) {
    return dayjs(date).format('DD.MM.YYYY HH:mm');
  }

  get sortedList() {
    const columnName: keyof ITask = this.sortValue.columnName as keyof ITask;

    const compare = (a: ITask, b: ITask) => {
      const aValue =
        typeof _get(a, columnName) === 'object' && _get(a, columnName) !== null
          ? (_get(a, columnName) as { id: string }).id
          : _get(a, columnName) !== null
          ? _get(a, columnName)
          : 0;
      const bValue =
        typeof _get(b, columnName) === 'object' && _get(b, columnName) !== null
          ? (_get(b, columnName) as { id: string }).id
          : _get(b, columnName) !== null
          ? _get(b, columnName)
          : 0;

      // if (!isNaN(aValue) && !isNaN(bValue)) {
      //   aValue = Number(aValue);
      //   bValue = Number(bValue);
      // }

      if (!aValue) {
        return this.sortValue.order === 'asc' ? -1 : 1;
      }
      if (!bValue) {
        return this.sortValue.order === 'asc' ? 1 : -1;
      }

      if (aValue < bValue) {
        return this.sortValue.order === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.sortValue.order === 'asc' ? 1 : -1;
      }
      return 0;
    };
    return this.filteredTasks().sort(compare);
  }

  get getPaginatedItems() {
    return this.sortedList.slice(
      this.currentPage * this.itemsPerPage,
      this.currentPage * this.itemsPerPage + this.itemsPerPage,
    );
  }

  hasSort(columnName: ColumnName, order: Order) {
    return this.sortValue.columnName === columnName && this.sortValue.order === order;
  }

  hasColumn(columnName: ColumnName) {
    return this.selectedColumns.includes(columnName);
  }

  get selectedColumns(): string[] {
    return this.columns;
  }

  setSort(columnName: ColumnName, order: Order) {
    this.sortValue = {
      columnName,
      order,
    };
  }

  isNew(task: ITask) {
    return dayjs(task.createdAt).isSame(dayjs(), 'date');
  }

  async selectTask(task: ITask) {
    if (this.hasSelectItemColumn) {
      this.$emit('select-task', task);
    }
  }
}
